const ROLE_LABEL_STATUSES = {
  ADMIN: "gcc_admin",
  OWNER: "gcc",
  PROJECT_MANAGER: "project_manager",
  SALES_MANAGER: "sales_manager",
  SALES_PM: "sales_pm"
} as const
//
// type RoleLabelStatusesKeys = keyof typeof ROLE_LABEL_STATUSES
// type RoleLabelStatuses = (typeof ROLE_LABEL_STATUSES)[RoleLabelStatusesKeys]
//
// const ROLE_LABEL_STATUSES_OBJ: Record<
//   string,
//   {
//     id: number
//     code: RoleLabelStatuses
//     name: string
//     isSystem: boolean
//     style: React.CSSProperties
//   }
// > = {
//   [ROLE_LABEL_STATUSES.ADMIN]: {
//     id: 409,
//     code: ROLE_LABEL_STATUSES.ADMIN,
//     name: "GCC Admin",
//     isSystem: true,
//     style: {
//       color: "#1565C0",
//       backgroundColor: "#E3F2FD",
//       borderColor: "#E3F2FD"
//     }
//   },
//   [ROLE_LABEL_STATUSES.OWNER]: {
//     id: 410,
//     code: ROLE_LABEL_STATUSES.OWNER,
//     name: "GCC Owner",
//     isSystem: true,
//     style: {
//       color: "#6E21F3",
//       backgroundColor: "#EFE3FD",
//       borderColor: "#EFE3FD"
//     }
//   },
//   [ROLE_LABEL_STATUSES.PROJECT_MANAGER]: {
//     id: 406,
//     code: ROLE_LABEL_STATUSES.PROJECT_MANAGER,
//     name: "Project Manager",
//     isSystem: true,
//     style: {
//       color: "#F57C00",
//       backgroundColor: "#FFF3E0",
//       borderColor: "#FFF3E0"
//     }
//   },
//   [ROLE_LABEL_STATUSES.SALES_MANAGER]: {
//     id: 408,
//     code: ROLE_LABEL_STATUSES.SALES_MANAGER,
//     name: "Sales Manager",
//     isSystem: true,
//     style: {
//       color: "#4CAF50",
//       backgroundColor: "#E8F5E9",
//       borderColor: "#E8F5E9"
//     }
//   },
//   [ROLE_LABEL_STATUSES.SALES_PM]: {
//     id: 407,
//     code: ROLE_LABEL_STATUSES.SALES_PM,
//     name: "Sales PM",
//     isSystem: true,
//     style: {
//       color: "#0097A7",
//       backgroundColor: "#E0F7FA",
//       borderColor: "#E0F7FA"
//     }
//   }
// }

// const LABEL_STATUSES_MAP = Object.fromEntries(
//   Object.values(ROLE_LABEL_STATUSES_OBJ).map((item) => [item.name, item])
// ) as Record<
//   string,
//   (typeof ROLE_LABEL_STATUSES_OBJ)[keyof typeof ROLE_LABEL_STATUSES_OBJ]
// >
//
// const LABEL_STATUSES_BY_CODE = Object.fromEntries(
//   Object.values(ROLE_LABEL_STATUSES_OBJ).map((item) => [item.code, item])
// ) as Record<
//   RoleLabelStatuses,
//   (typeof ROLE_LABEL_STATUSES_OBJ)[keyof typeof ROLE_LABEL_STATUSES_OBJ]
// >

export {
  ROLE_LABEL_STATUSES
  // ROLE_LABEL_STATUSES_OBJ,
  // LABEL_STATUSES_MAP,
  // LABEL_STATUSES_BY_CODE,
  // type RoleLabelStatuses
}
